/** Chart-line — Figma 5092:31345, outer 32×32, leaf inset 12.5% */
const ChartLineIcon = ({ className }: { className?: string }) => (
    <span
        className={`relative inline-block size-8 shrink-0 overflow-hidden ${className ?? ""}`}
        aria-hidden
    >
        <span className="absolute inset-[12.5%]">
            <span className="absolute inset-[-2.08%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.5 0.5V21.8333C0.5 22.5406 0.780951 23.2189 1.28105 23.719C1.78115 24.219 2.45942 24.5 3.16667 24.5H24.5M21.8333 8.5L15.1667 15.1667L9.83333 9.83333L5.83333 13.8333"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

export default ChartLineIcon;
